const colorPalettes = [
    // tops
    { colors: ["#A94A4A", "#F4D793", "#FFF6DA", "#889E73"] },
    { colors: ["#08D9D6", "#252A34", "#FF2E63", "#EAEAEA"] },
    { colors: ["#1B262C", "#0F4C75", "#3282B8", "#BBE1FA"] },
    { colors: ["#DEAA79", "#FFE6A9", "#B1C29E", "#659287"] },
    { colors: ["#F5F7F8", "#F4CE14", "#495E57", "#45474B"] },
    { colors: ["#222831", "#393E46", "#00ADB5", "#EEEEEE"] },

    // others
    // { colors: ["#F6F5F2", "#F0EBE3", "#F3D0D7", "#FFEFEF"] },
    // { colors: ["#FF204E", "#A0153E", "#5D0E41", "#00224D"] },
    { colors: ["#FFF3C7", "#FEC7B4", "#FC819E", "#F7418F"] },
    { colors: ["#050C9C", "#3572EF", "#3ABEF9", "#A7E6FF"] },
    { colors: ["#001F3F", "#3A6D8C", "#6A9AB0", "#EAD8B1"] },
    { colors: ["#C40C0C", "#FF6500", "#FF8A08", "#FFC100"] },
    { colors: ["#071952", "#088395", "#37B7C3", "#EBF4F6"] },
    { colors: ["#F9F7F7", "#DBE2EF", "#3F72AF", "#112D4E"] },
    { colors: ["#364F6B", "#3FC1C9", "#F5F5F5", "#FC5185"] },
    { colors: ["#212121", "#323232", "#0D7377", "#14FFEC"] },
    { colors: ["#2B2E4A", "#E84545", "#903749", "#53354A"] },
    { colors: ["#E23E57", "#88304E", "#522546", "#311D3F"] },

]

export { colorPalettes }